<div class="pto-project-health-main-container">
  <div class="project-health-title-and-filter-container">
    <span class="project-health-title">{{'projects_overview_health' | translate}}</span>
    <div class="project-health-filter-dropdown">
      <p-dropdown
        [options]="projectTypes"
        [(ngModel)]="filterType"
        optionLabel="name"
        [placeholder]="('projects_overview_filter_by_type' | translate)"
        (onChange)="changeType($event.value)"
        dropdownIcon="bi bi-caret-down-fill"
        dataKey="uuid">
      </p-dropdown>
    </div>
  </div>
  <div class="project-health-data-container">
    <div class="project-health-score-and-changes data-container">
      <app-gauge-display
          [value]="aggregateValues.score"
          [width]="250"
          [height]="220"
          [isOnProjectTeam]="false"
          [isOnTeamCodex]="true"
          [trend]="aggregateValues.score > aggregateValues.previousScore ? 'up':'down'"
          [colorStart]="aggregateValues.color"
          [colorEnd]="aggregateValues.color"
          [backgroundColor]="'rgba(240, 243, 250, 1)'">
      </app-gauge-display>
      <div class="change-index-container">
          <div class="change-index-value">
              <img *ngIf="aggregateValues.diff" [class]="'arrow-' + aggregateValues.diff.trend" [src]="'../../../assets/svg/indicator-arrow-'+ aggregateValues.diff.trend +'.svg'">
              <i class="trend-dash bi bi-dash-lg" *ngIf="!aggregateValues.diff"></i>
              <span *ngIf="aggregateValues.diff" class="change-index-value-diff">{{(aggregateValues.diff.value > 0) ? ('+'+aggregateValues.diff.value+'%'):(aggregateValues.diff.value+'%')}}</span>
          </div>
          <span class="change-index-value-text">{{'projects_overview_health_changes'|translate}}</span>
      </div>
    </div>
    <div class="project-health-response-rate-container data-container">
      <span class="project-health-response-rate-title">{{'projects_overview_average_response_rate' | translate}}</span>
      <div [ngClass]="aggregateValues.responseRateFadeColor" class="project-health-response-rate-value-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <g filter="url(#filter0_d_430_11651)">
            <circle cx="21.7715" cy="21.4248" r="20.4248" [attr.fill]="aggregateValues.responseRateColor"/>
            </g>
            <path d="M17.2798 31.8525L13.5502 27.6322C13.3817 27.4453 13.3817 27.16 13.5502 26.9657L17.2798 22.7503C17.5897 22.4011 18.1603 22.6224 18.1603 23.0823V25.8073H25.1068C26.0573 25.8073 26.8345 25.0302 26.8345 24.0784V23.1389C26.8345 22.6987 27.0288 22.2855 27.3657 22.0002L28.7835 20.8148C29.1906 20.4656 29.8251 20.7631 29.8251 21.3017V24.1423C29.8251 26.7124 27.7408 28.7979 25.1707 28.7979H18.1603V31.5229C18.1603 31.8254 17.9119 32.0222 17.6536 32.0222C17.5208 32.0222 17.3856 31.9705 17.2798 31.8525ZM13.7186 21.5526V18.712C13.7186 16.142 15.803 14.0638 18.373 14.0638H25.3847V11.3388C25.3847 10.8789 25.954 10.6576 26.2651 11.0019L29.9936 15.2222C30.162 15.4165 30.162 15.7017 29.9936 15.8887L26.2651 20.104C25.954 20.4533 25.3847 20.2393 25.3847 19.7745V17.0544H18.4382C17.4803 17.0544 16.7092 17.8242 16.7092 18.776V19.7154C16.7092 20.1557 16.515 20.5689 16.1793 20.8541L14.7614 22.0396C14.6372 22.1429 14.4946 22.1896 14.3556 22.1896C14.0285 22.1896 13.7186 21.9313 13.7186 21.5526Z" fill="white"/>
            <defs>
            <filter id="filter0_d_430_11651" x="0.717064" y="0.370385" width="47.1458" height="47.1458" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="2.51846" dy="2.51846"/>
            <feGaussianBlur stdDeviation="1.57404"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0901961 0 0 0 0 0.211765 0 0 0 0.0392157 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_430_11651"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_430_11651" result="shape"/>
            </filter>
            </defs>
        </svg>
        <div class="d-flex gap-2 align-items-end">
            <h2 [style]="{'font-size':'4.2rem', 'font-weight':'600', 'line-height': '.85'}">
                {{aggregateValues.responseRate}}
            </h2>
            <h2 [style]="{'font-size': '2rem','line-height': '1.2'}">%</h2>
        </div>
      </div>
      <div class="project-health-response-rate-details">
       <div class="details-font-container">
           <span class="me-2">{{'projects_overview_active_projects' | translate}}</span>
           <span class="doted-space"></span>
           <span class="ms-2 fw-bold">{{aggregateValues.activeProjects}}</span>
       </div>
       <div class="details-font-container">
           <span class="me-2">{{'projects_overview_risk_projects' | translate}}</span>
           <span class="doted-space"></span>
           <span class="ms-2 fw-bold">{{aggregateValues.risk}}</span>
       </div>
       <div class="details-font-container">
           <span class="me-2">{{'projects_overview_improving_projects' | translate}}</span>
           <span class="doted-space"></span>
           <span class="ms-2 fw-bold">{{aggregateValues.improved}}</span>
       </div>
      </div>
    </div>
    <div class="project-health-indicators-container data-container">
      <div class="topic-indicator-container" *ngFor="let indicator of aggregateValues.indicators">
          <div [ngStyle]="{'background-image':indicator.gradientColor}" class="topic-indicator-icon-container">
              <app-dinamic-indicator-display
                  [indicatorName]="indicator.slug" [color]="'#FFFFFF'"></app-dinamic-indicator-display>
          </div>
          <span class="topic-indicator-title">{{indicator.title}}</span>
          <div class="topic-indicator-value-container">
              <span class="topic-indicator-value">{{indicator.currentScore}}</span>
              <span class="topic-indicator-value-percentage">%</span>
              <img class="topic-indicator-trend" *ngIf="indicator.trend"
                  [class]="'arrow-' + indicator.trend"
                  [src]="'../../../assets/svg/indicator-arrow-'+indicator.trend+'.svg'">
          </div>
      </div>
    </div>
  </div>
</div>
